export const isProduction = () => process.env.NODE_ENV === 'production';
export const isStaging = () => process.env.REACT_APP_ENV === 'staging';
export const isDevelopment = () => process.env.NODE_ENV === 'development';
export const isTest = () => process.env.NODE_ENV === 'test';

const getEnv = () => ({
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_GOOGLE_AUTH_CLIENT_ID: process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID,
});

export const env = getEnv();
